export default __webpack_public_path__ + "static/media/notification.15a9ef19.svg";